import * as API from "@/endpoints";
import Vue from "vue";
import _ from "lodash";
import Axios from "axios";
import VueCookie from "vue-cookie";
import { Message } from "iview";

function getActionId(actions, action) {
    let findIndx = _.findIndex(actions, { "action": action });
    let finAction = actions[findIndx];
    return finAction.id;
};

export default {
    namespaced: true,
    state: {
        isLoadingResiliency: false,
        isLoadingSettingResiliencyPoint: false,
        isLoadingUserActions: false,
        isLogLoading: false,
        isNextLogLoading: false,
        isTrackResiliencyLoader: false,
        isModuleResiliencyLoader: false,
        userActions: {},
        userTrackResiliency: {},
        userModuleResiliency: {},
        resiliencyPoints: {
            Cope: 0,
            Heal: 0,
            Nourish: 0,
            Thrive: 0
        },
        mlog: {
            cope: {},
            thrive: {},
            heal: {},
            nourish: {}
        },
        pointsModal: {
            isShow: false,
            category: "heal"
        }
    },
    mutations: {
        setResiliency(state, v) {
            Vue.set(state, 'resiliencyPoints', v)
        },
        setUserTrackResiliency(state, v) {
            Vue.set(state, 'userTrackResiliency', v)
        },
        setUserModuleResiliency(state, v) {
            Vue.set(state, 'userModuleResiliency', v)
        },
        setUserActions(state, v) {
            Vue.set(state, 'userActions', v)
        },
        setResiliencyLoader(state, v) {
            Vue.set(state, 'isLoadingResiliency', v)
        },
        setTrackResiliencyLoader(state, v) {
            Vue.set(state, 'isTrackResiliencyLoader', v)
        },
        setModuleResiliencyLoader(state, v) {
            Vue.set(state, 'isModuleResiliencyLoader', v)
        },
        settingResiliencyPointLoader(state, v) {
            Vue.set(state, 'isLoadingSettingResiliencyPoint', v)
        },
        setNextLogLoader(state, v) {
            Vue.set(state, 'isNextLogLoading', v)
        },
        setLogLoader(state, v) {
            Vue.set(state, 'isLogLoading', v)
        },
        settingActionListLoader(state, v) {
            Vue.set(state, 'isLoadingUserActions', v)
        },
        appendCatLog(state, v) {
            // Vue.set(state.mlog, v.category, v.data)
            state.mlog[v.category].data = state.mlog[v.category].data.concat(v.data.data)
            Vue.set(state.mlog[v.category], "next_link", v.data.next_link)
            Vue.set(state.mlog[v.category], "page", v.data.page)
            Vue.set(state.mlog[v.category], "per_page", v.data.per_page)
            Vue.set(state.mlog[v.category], "prev_link", v.data.prev_link)
            Vue.set(state.mlog[v.category], "total", v.data.total)
        },
        setCatLog(state, v) {
            Vue.set(state.mlog, v.category, v.data)
        },
        setShowPointsModal(state, v) {
            Vue.set(state.pointsModal, 'isShow', v)
        },
        setModalCategory(state, v) {
            Vue.set(state.pointsModal, 'category', v)
        },
        setVisited(state, v) {
            let newData = {};
            let engageCourse = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`));

            console.log(engageCourse);

            if (v.type === 'course')
                newData = {
                    userStory: v.userStory,
                    category: v.category,
                    course: v.id
                }
            if (v.type === 'track')
                newData = {
                    ...engageCourse,
                    article: v.id
                }

            console.log(newData);

            VueCookie.set(
                `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`,
                JSON.stringify(newData)
            );
        }
    },
    getters: {
        getModalCategory: (state) => {
            return state.pointsModal.category;
        },
        userTrackResiliency: (state) => {
            return state.userTrackResiliency;
        },
        userModuleResiliency: (state) => {
            return state.userModuleResiliency;
        },
        isTrackResiliencyLoader: (state) => {
            return state.isTrackResiliencyLoader;
        },
        isModuleResiliencyLoader: (state) => {
            return state.isModuleResiliencyLoader;
        },
        showPointsModal: (state) => {
            return state.pointsModal.isShow;
        },
        getCurrentUserResiliency: (state) => {
            return state.resiliencyPoints;
        },
        getUserActions: (state) => {
            return state.userActions;
        },
        isLoadingResiliency: (state) => {
            return state.isLoadingResiliency
        },
        isLoadingSettingResiliencyPoint: (state) => {
            return state.isLoadingSettingResiliencyPoint
        },
        isLoadingUserActions: (state) => {
            return state.isLoadingUserActions
        },
        getLog: (state) => {
            return (v) => {
                return _.get(state.mlog, v);
            }
        },
        getNextLogLoader: (state) => {
            return state.isNextLogLoading
        },
        getLogLoader: (state) => {
            return state.isLogLoading
        }
    },
    actions: {
        async getCurrentUserTrackPointsFinish(context, payload) {
            try {
                context.commit("setTrackResiliencyLoader", true);
                let res = await Axios.get(`${API.endpoints.base}/journal/${payload.journalId}/track/${payload.trackId}/points?brand_id=${context.rootGetters["user/brandInfo"].id}`);
                if (res.status == 200) 
                    return Promise.resolve(res.data)
            } catch (e) {
                console.log(e)
                return Promise.reject(e.response)
            } finally {
                context.commit("setTrackResiliencyLoader", false);
            }
        },
        async getCurrentUserTrackPoints(context, payload) {
            try {
                context.commit("setTrackResiliencyLoader", true);
                let res = await Axios.get(`${API.endpoints.base}/journal/${payload.journalId}/track/${payload.trackId}/points?brand_id=${context.rootGetters["user/brandInfo"].id}`);
                if (res.status == 200) context.commit("setUserTrackResiliency", res.data);
            } catch (e) {
                console.log(e)
            } finally {
                context.commit("setTrackResiliencyLoader", false);
            }
        },
        async getCurrentUserModulePoints(context, payload) {
            try {
                context.commit("setModuleResiliencyLoader", true);
                let res = await Axios.get(`${API.endpoints.base}/journal/${payload.journalId}/module/${payload.moduleId}/points?brand_id=${context.rootGetters["user/brandInfo"].id}`);
                if (res.status == 200) context.commit("setUserModuleResiliency", res.data);
            } catch (e) {
                console.log(e)
            } finally {
                context.commit("setModuleResiliencyLoader", false);
            }
        },

        async getCurrentUserPoints(context, payload) {
            try {
                context.commit("setResiliencyLoader", true);
                let res = await Axios.get(`${API.endpoints.base}/journal/${payload}/points?brand_id=${context.rootGetters["user/brandInfo"].id}`);
                if (res.status == 200) context.commit("setResiliency", res.data);
            } catch (e) {
                console.log(e)
            } finally {
                context.commit("setResiliencyLoader", false);
            }
        },
        async getUserActions(context) {
            try {
                context.commit("settingActionListLoader", true);
                let res = await Axios.get(`${API.endpoints.base}/point/action`);
                if (res.status == 200) context.commit("setUserActions", res.data);
            } catch (e) {
                console.log(e)
            } finally {
                context.commit("settingActionListLoader", false);
            }
        },
        async getCurrentUserCategoryNextLog(context, payload) {
            try {
              context.commit("setNextLogLoader", true);
              let res = await Axios.get(
                `${API.endpoints.base}/journal/${payload.journalId}/points/log`,
                {
                  params: {
                    brand_id: payload.brandId,
                    category: payload.category,
                    page: payload.page
                  }
                }
              );
              if (res.status == 200)
                context.commit("appendCatLog", {
                  category: payload.category,
                  data: res.data
                });
            } catch (e) {
              Message.error({
                closable: true,
                duration: 3,
                content: _.get(e, "response.error.message", "Error getting logs.")
              });
            } finally {
              context.commit("setNextLogLoader", false);
            }
        },
        async getCurrentUserCategoryLog(context, payload) {
            try {
                context.commit("setLogLoader", true);
                let res = await Axios.get(`${API.endpoints.base}/journal/${payload.journalId}/points/log?brand_id=${context.rootGetters["user/brandInfo"].id}&category=${payload.category}`);
                if (res.status == 200) {
                    context.commit("setCatLog", {
                        category: payload.category,
                        data: res.data
                    });
                }
            } catch (e) {
                Message.error({
                    closable: true,
                    duration: 3,
                    content: _.get(e, "response.error.message", "Error getting logs.")
                });
            } finally {
                context.commit("setLogLoader", false);
            }
        },
        async setUserActionPoints(context, payload) {
            if (context.rootGetters["user/userInfo"].user_type === "guest") return false;
            if (_.get(context.rootGetters["user/brandInfo"], "allow_points", 0) === 0) return false;
            try {
                context.commit("settingResiliencyPointLoader", true);
                console.log(getActionId(context.getters["getUserActions"], payload.action));

                let journalId = context.rootGetters["user/userInfo"].journal_id;
                let data = {
                    action_id: getActionId(context.getters["getUserActions"], payload.action),
                    category: "All"
                }

                if (_.get(payload, "user_story_id"))
                    Vue.set(data, "user_story_id", _.get(payload, "user_story_id"));
                if (_.get(payload, "module_id"))
                    Vue.set(data, "module_id", _.get(payload, "module_id"));
                if (_.get(payload, "track_id"))
                    Vue.set(data, "track_id", _.get(payload, "track_id"));
                if (_.get(payload, "element_id"))
                    Vue.set(data, "element_id", _.get(payload, "element_id"));
                if (_.get(payload, "category"))
                    Vue.set(data, "category", _.get(payload, "category"));
                if (_.get(payload, "duration"))
                    Vue.set(data, "duration", _.get(payload, "duration"));
                if (_.get(payload, "video_link"))
                    Vue.set(data, "video_link", _.get(payload, "video_link"));

                data.brand_id = context.rootGetters["user/brandInfo"].id;

                let res = await Axios.post(`${API.endpoints.base}/journal/${journalId}/points`, data);

                if (res.data) context.dispatch("getCurrentUserPoints", journalId)

                console.log("Resiliency:", payload, res)
            } catch (e) {
                console.log(e)
            } finally {
                context.commit("settingResiliencyPointLoader", false);
            }
        }
    }
}
